import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PUBLISH_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BatchApprovalPage } from '@/features/publish/pages/BatchApprovalPage';
import { batchSearchSchema } from '@/features/publish/types/publish.types';

export const Route = createFileRoute('/_auth/publish/accounts')({
  beforeLoad: () => requirePermission(PUBLISH_PERMISSIONS.ACCOUNTS_VIEW),
  validateSearch: batchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Accounts Disburse Panel">
      <Suspense fallback={<PageLoader />}>
        <BatchApprovalPage stage="accounts" />
      </Suspense>
    </ErrorBoundary>
  ),
});
